import atcActionTypes from 'yoda-site-components/lib/actionTypes/ProductOptionsActionTypes';
import {
    ADDTOCART_POST_SUCCESS,
    ADDTOCART_KEEPSHOPPING_ONCLICK,
    ITEM_UPDATE_SUCCESS,
    ADDTOCART_STICKY_ONCLICK,
    ADDTOCART_ONCLICK,
} from '../actionTypes/AddToCartActionTypes';

const initialState = {
    isAddToCartSuccess: false,
    isUpdateCartSuccess: false,
    stickyHeaderOnClick: false,
    isStoreModalAtc: false,
    atcOnClick: false,
};

function AddToCartReducer(state = initialState, action) {
    switch (action.type) {
        case ADDTOCART_POST_SUCCESS:
            return {
                isAddToCartSuccess: true,
                isUpdateCartSuccess: false,
                stickyHeaderOnClick: action.cartSuccess.stickyHeaderOnClick,
                isStoreModalAtc: action.cartSuccess.isStoreModalAtc,
            };
        case ADDTOCART_KEEPSHOPPING_ONCLICK:
            return {
                isAddToCartSuccess: false,
                isUpdateCartSuccess: false,
                stickyHeaderOnClick: action.payload.stickyHeaderOnClick,
            };
        case ITEM_UPDATE_SUCCESS:
            return {
                isAddToCartSuccess: false,
                isUpdateCartSuccess: true,
                stickyHeaderOnClick: action.result.stickyHeaderOnClick,
                isStoreModalAtc: action.result.isStoreModalAtc,
            };
        case ADDTOCART_STICKY_ONCLICK:
            return {
                isAddToCartSuccess: false,
                isUpdateCartSuccess: false,
                stickyHeaderOnClick: true,
                atcOnClick: true,
            };
        case ADDTOCART_ONCLICK:
            return {
                isAddToCartSuccess: false,
                isUpdateCartSuccess: false,
                stickyHeaderOnClick: false,
                atcOnClick: true,
            };
        case atcActionTypes.RESET_ATC_BTN_CLICK:
            return initialState;
        default:
            return state;
    }
}

export default AddToCartReducer;
